import { render, staticRenderFns } from "./SupplierScoreTab.vue?vue&type=template&id=d21f3228&"
import script from "./SupplierScoreTab.vue?vue&type=script&lang=js&"
export * from "./SupplierScoreTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports